import * as types from "./types";

export const setSlideToIndex = (index) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_SLIDE_TO_INDEX,
      payload: index,
    });
  };
};

export const resetSlideToIndex = () => {
  return (dispatch) => {
    dispatch({
      type: types.RESET_SLIDE_TO_INDEX,
      payload: {},
    });
  };
};
